import { extractVimeoId } from '@/lib/vimeo';

export function getVideoEmbedInfo(url: string): { type: 'youtube' | 'loom' | 'vimeo' | null; embedUrl: string | null } {
  if (!url) return { type: null, embedUrl: null };

  try {
    // Normalize URL - add https:// if missing
    let normalizedUrl = url.trim();
    if (!normalizedUrl.startsWith('http://') && !normalizedUrl.startsWith('https://')) {
      normalizedUrl = 'https://' + normalizedUrl;
    }

    const urlObj = new URL(normalizedUrl);
    
    // YouTube detection
    if (urlObj.hostname === 'www.youtube.com' || urlObj.hostname === 'youtube.com') {
      const videoId = urlObj.searchParams.get('v');
      if (videoId) {
        return {
          type: 'youtube',
          embedUrl: `https://www.youtube.com/embed/${videoId}`
        };
      }
    } else if (urlObj.hostname === 'youtu.be') {
      const videoId = urlObj.pathname.slice(1);
      if (videoId) {
        return {
          type: 'youtube',
          embedUrl: `https://www.youtube.com/embed/${videoId}`
        };
      }
    }
    
    // Vimeo detection
    if (urlObj.hostname === 'www.vimeo.com' || urlObj.hostname === 'vimeo.com' || urlObj.hostname === 'player.vimeo.com') {
      const videoId = extractVimeoId(url);
      if (videoId) {
        return {
          type: 'vimeo',
          embedUrl: `https://player.vimeo.com/video/${videoId}`
        };
      }
    }
    
    // Loom detection
    if (urlObj.hostname === 'www.loom.com' || urlObj.hostname === 'loom.com') {
      const pathParts = urlObj.pathname.split('/');
      const shareIndex = pathParts.indexOf('share');
      if (shareIndex !== -1 && pathParts[shareIndex + 1]) {
        const videoId = pathParts[shareIndex + 1];
        return {
          type: 'loom',
          embedUrl: `https://www.loom.com/embed/${videoId}`
        };
      }
    }
  } catch (e) {
    // Invalid URL
    return { type: null, embedUrl: null };
  }

  return { type: null, embedUrl: null };
}